import { User } from "firebase/auth"
import { firebaseDB } from "../firebase"
import { addDoc, collection, doc, getDoc, setDoc, Timestamp } from "firebase/firestore";

export const createUserIfNotExists = async (firebaseUser: User) => {
	const userRef = doc(firebaseDB, "users", firebaseUser.uid);
	const userDoc = await getDoc(userRef);
	if (!userDoc.exists()) {
		const defaultBudgetGroup = {
				friendlyName: `${firebaseUser.displayName}-personal`,
				createdAt: Timestamp.now(),
				createdBy: firebaseUser.uid,
				userIds: [firebaseUser.uid]
			};

		const budgetGroupsCollectionsRef = collection(firebaseDB, "budgetGroups");
		const budgetGroup = await addDoc(budgetGroupsCollectionsRef, defaultBudgetGroup);
		await setDoc(doc(firebaseDB, "users", firebaseUser.uid), {
					userId: firebaseUser.uid,
					email: firebaseUser.email,
					friendlyName: firebaseUser.displayName,
					budgetGroups: [budgetGroup.id],
					defaultBudgetGroup: budgetGroup.id,
					joinedAt: Timestamp.now(),
		});
	}
};
